const axios = require('axios');

export const fetchLinkPreview = async link => {
  const { data } = await axios(
    `${process.env.EMBEDLY_API_URL}?url=${link}&key=${process.env.EMBEDLY_KEY}`
  );
  return data;
};
